import React, { FC } from 'react'
import LazyLoad from 'react-lazyload'
import './index.scss'
interface BlockProps {
  id: string
  pid: string
  config: {
    href: string
    contextUrl: string
    link?: string
    deepLink?: string
  }
  clickTo(type: string, deeplink: string, link: string, id: string): void
}

const Block: FC<BlockProps> = ({ config, clickTo, id }) => {
  const { href, link, deepLink } = config || {}
  const clickHandler = () => {
    clickTo?.('block', deepLink, link, id)
  }
  return (
    <div className="custom-container" onClick={clickHandler}>
      <LazyLoad overflow={true} height={100} className="lazyImgBox">
        <object className="custom-wrapper" data={href} type="image/svg+xml" />
      </LazyLoad>
    </div>
  )
}

export default Block
